/* rc-collection — filter enhancements + instant (AJAX) filtering.
   The Team/Year/Type dropdowns are native <details>, so they open/close with NO JS.
   This adds: one dropdown open at a time, click-outside close, the mobile slide-up sheet,
   and INSTANT filtering — filter / chip / clear / pagination links fetch the filtered page
   and swap the grid (count, dropdowns, chips, cars) in place instead of reloading. Falls
   back to a normal page load on any error. Event-delegated + idempotent. Load once, defer. */
(function () {
  if (window.__rcCollInit) return;
  window.__rcCollInit = true;

  function closeGroups(except) {
    document.querySelectorAll('.rc-cfilter__group[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  function closeSheet() {
    var sec = document.querySelector('.rc-collection.is-filters-open');
    if (sec) { sec.classList.remove('is-filters-open'); document.body.style.overflow = ''; }
  }

  /* ---- Instant filtering ---- */
  var busy = false;
  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/[^\w-]/g, '\\$&'); }

  function swap(url, section, opts) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.rc-collection .rc-container');
        var cur = section.querySelector('.rc-container');
        if (!fresh || !cur) throw new Error('no container');
        cur.innerHTML = fresh.innerHTML;
        if (opts.push && window.history && history.pushState) history.pushState({ rcFilter: true }, '', url);
        if (opts.openKey) {
          var g = section.querySelector('.rc-cfilter__group[data-rc-cfilter-key="' + esc(opts.openKey) + '"]');
          if (g) g.open = true;
        }
        if (opts.scroll) {
          var top = section.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
        }
      });
  }

  function loadFilter(url, section, opts) {
    if (busy) return;
    busy = true;
    section.classList.add('is-loading');
    section.setAttribute('aria-busy', 'true');
    swap(url, section, opts)
      .catch(function () { window.location.assign(url); })
      .then(function () {
        busy = false;
        section.classList.remove('is-loading');
        section.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    /* Mobile sheet open/close */
    var open = e.target.closest('[data-rc-filter-open]');
    if (open) {
      var s1 = open.closest('.rc-collection');
      if (s1) { s1.classList.add('is-filters-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-rc-filter-close]') || e.target.closest('[data-rc-filter-backdrop]')) { closeSheet(); return; }

    /* Instant filtering — intercept filter value / chip / clear / pagination links */
    var link = e.target.closest('.rc-cfilter__value, .rc-collection__chip, [data-rc-filter-clear], .rc-collection__pagination a');
    if (link && link.href) {
      var section = link.closest('.rc-collection');
      if (section) {
        e.preventDefault();
        var grp = link.closest('.rc-cfilter__group');
        loadFilter(link.href, section, {
          push: true,
          openKey: grp ? grp.getAttribute('data-rc-cfilter-key') : null,
          scroll: !!link.closest('.rc-collection__pagination')
        });
        return;
      }
    }

    /* click anywhere outside a filter group closes the open dropdown (desktop) */
    if (!e.target.closest('.rc-cfilter__group')) closeGroups(null);
  });

  /* Back / forward — re-sync the grid to the URL without pushing a new entry */
  window.addEventListener('popstate', function () {
    var section = document.querySelector('.rc-collection');
    if (!section) return;
    busy = false;
    loadFilter(window.location.href, section, { push: false });
  });

  /* One dropdown open at a time (the toggle event doesn't bubble → capture) */
  document.addEventListener('toggle', function (e) {
    var g = e.target;
    if (g && g.classList && g.classList.contains('rc-cfilter__group') && g.open) closeGroups(g);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeGroups(null); closeSheet(); }
  });
})();
